var _defs, _circle, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolanaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 178.3,
    y: 206.01,
    width: 443.4,
    height: 387.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 197.56,
    y1: 199.56,
    x2: 602.44,
    y2: 604.44,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 802)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9945ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#7962e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00d18c"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "solana-logo-freelogovectors.net_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 369.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M258.52,501.85a14.86,14.86,0,0,1,5-3.59,15.13,15.13,0,0,1,6-1.27l338.61.28a7.44,7.44,0,0,1,5.49,12.46l-72.11,79.4a14.86,14.86,0,0,1-11,4.86l-338.6-.28a7.45,7.45,0,0,1-5.49-12.46Zm355.07-66.09a7.44,7.44,0,0,1-5.49,12.46l-338.6.28a14.86,14.86,0,0,1-11-4.86L186.41,364.2a7.47,7.47,0,0,1-1.84-3.82,7.43,7.43,0,0,1,3.27-7.43,7.52,7.52,0,0,1,4.06-1.22l338.61-.27a14.81,14.81,0,0,1,11,4.86ZM258.52,210.87a14.81,14.81,0,0,1,11-4.86l338.61.28a7.44,7.44,0,0,1,6.8,4.44,7.42,7.42,0,0,1-1.31,8l-72.11,79.4a14.86,14.86,0,0,1-11,4.86l-338.6-.28a7.42,7.42,0,0,1-6.8-4.45,7.46,7.46,0,0,1,1.31-8Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 800,
    height: 800
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaIcon);
export default __webpack_public_path__ + "static/media/solanaIcon.317aa4d31962f713b952053e277cad6f.svg";
export { ForwardRef as ReactComponent };